import { Checkbox } from '@wkda/styleguide';
import { Field } from 'react-final-form';
import { jsx as _jsx } from "react/jsx-runtime";
export function checkboxRenderer(_ref) {
  let {
    name,
    onChange,
    onBlur,
    onFocus,
    mktSelector: _mktSelector,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Field, {
    name: name,
    render: _ref2 => {
      let {
        input
      } = _ref2;
      const {
        type: _type,
        ...restInput
      } = input;
      return /*#__PURE__*/_jsx(Checkbox, {
        id: input.name,
        ...props,
        ...restInput,
        onChange: e => {
          restInput.onChange(e);
          onChange?.(e);
        },
        onFocus: e => {
          restInput.onFocus(e);
          onFocus?.(e);
        },
        onBlur: e => {
          restInput.onBlur(e);
          onBlur?.(e);
        }
      });
    }
  });
}